import { ScrollLock } from './scrollLock';
/* eslint-disable @typescript-eslint/no-explicit-any */
export class LinkScroll {
    // tslint:disable-next-line: variable-name
    private static _instance: LinkScroll;
    private _scrollLock: ScrollLock;
    private _baseElement: Element;
    private _floatElement: Element;
    private _stickElement: Element;
    private desktopMinWidth = 1200;
    private shouldRun = false;
    private heightDiff: number;
    private bufferHeight: number;
    private deltaMarginTop: number;
    private isResizing = false;
    private resizeTimer: number;
    static get instance() {
        return this._instance || (this._instance = new this());
    }

    public setComponent(scrollLock: ScrollLock, baseElement: Element, floatElement: Element, stickElement: Element) {
        if (typeof window !== 'undefined') {
            // only run on client side
            this.cleanBinding();
            this._scrollLock = scrollLock;
            this._baseElement = baseElement;
            this._floatElement = floatElement;
            this._stickElement = stickElement;
            this.onResize = this.onResize.bind(this);
            this.onScroll = this.onScroll.bind(this);
            this.updateBinding();
        }
    }

    public destroy(): void {
        this.cleanBinding();
    }


    private updateBinding() {
        // init and bind view resize
        this.onResize();
        window.addEventListener('resize', this.onResize);

        // init and bind scroll
        window.addEventListener('scroll', this.onScroll);
    }

    private cleanBinding() {
        // clean all event binding
        window.removeEventListener('resize', this.onResize);
        window.removeEventListener('scroll', this.onScroll);
    }

    private onResize() {
        this.isResizing = true;
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
            this.shouldRun = window.innerWidth >= this.desktopMinWidth &&
                this._baseElement.scrollHeight > this._stickElement.scrollHeight &&
                this._stickElement.scrollHeight >= window.innerHeight &&
                this._stickElement.scrollHeight > 0 &&
                this._baseElement.scrollHeight > 0;
            if (this.shouldRun) {
                this.heightDiff = Math.ceil(this._baseElement.scrollHeight - this._stickElement.scrollHeight);
                this.bufferHeight = Math.max(0, Math.ceil(this._stickElement.scrollHeight - window.innerHeight));
            } else {
                this.resetMargin();
            }
            this.isResizing = false;
        }, 150);
    }

    private onScroll() {
        // TODO: as content service, maybe find a general way to detect if currently scrollable or not
        // Usecase: basekModal will not apply scroll lock right now
        requestAnimationFrame(() => {
            if (this._scrollLock.isLocked)
                return;
            if (this.isResizing)
                return;

            if (window.scrollY > this.bufferHeight) {
                if (window.scrollY + window.innerHeight <= this._baseElement.scrollHeight) {
                    this.deltaMarginTop = window.scrollY - this.bufferHeight;
                    this.floatElement.setAttribute('style', `margin-top: ${Math.ceil(this.deltaMarginTop)}px`);
                } else {
                    this.floatElement.setAttribute('style', `margin-top: ${Math.ceil(this.heightDiff)}px`);
                }
                this.stickElement.setAttribute('style', 'bottom: 0px');
            } else {
                this.deltaMarginTop = 0;
                this.resetMargin();
            }
        });
    }

    private resetMargin() {
        this.deltaMarginTop = 0;
        this.floatElement.removeAttribute('style');
        this.stickElement.removeAttribute('style');
    }

    get baseElement() {
        return this._baseElement;
    }

    get floatElement() {
        return this._floatElement;
    }

    get stickElement() {
        return this._stickElement;
    }
}
